module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('i', [_vm._v("Author’s Note")])])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "normal"
  }, [_vm._v("The excerpts of trials and arguments that appear in this book have had no editing apart from punctuation—court stenographers are excellent at catching sounds, but they are not so good on rests, and no witness says “comma”—the correction of an occasional word where there was an obvious mistake in stenography or transcription, and, at a few points only, the use of italics where vocal stress was especially important to the meaning. Books dealing with the law sometimes indulge in revision of what was said in court, not to change the substance, but because extemporaneous speech, put on paper, tends to read poorly and is often downright embarrassing. The indulgence damages accuracy and deadens flavor. Accordingly, apart from the small efforts to make reproduction more exact, I have used the official court reporters’ transcript of their notes, without any attempt to spare the literary sensitivities of the reader or the ego of the speaker.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The description of the affairs of clients, and conversations with them, is in each instance with the client’s permission.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 75
// module chunks = 0